import { useSyncExternalStore, use, useDeferredValue } from "react";
import { watchSharedData, getSharedData } from "./clientStorage.js";
import "rxjs/internal/BehaviorSubject";
import "rxjs/internal/Subject";
import "rxjs";
const useSharedData = (id, reducer = (a) => a, serverSideLoader) => {
  const value = useSyncExternalStore(
    (callback) => {
      return watchSharedData(id, (result) => {
        if (!result) {
          callback(void 0);
        } else {
          callback(reducer(result));
        }
      });
    },
    () => {
      const result = getSharedData(id);
      if (!result) {
        return void 0;
      } else {
        return reducer(result);
      }
    },
    () => {
      if (!serverSideLoader) {
        return void 0;
      }
      const serverSideResult = serverSideLoader();
      if (isPromise(serverSideResult)) {
        return use(serverSideResult.then(reducer));
      }
      return reducer(serverSideResult);
    }
  );
  return useDeferredValue(value);
};
function isPromise(obj) {
  return !!obj && typeof obj.then === "function";
}
export {
  useSharedData
};
